const DESKTOP_MQ = '(min-width: 768px)';
const REDUCE_MQ = '(prefers-reduced-motion: reduce)';

const isDesktopVideoOk = () =>
  !window.matchMedia(REDUCE_MQ).matches && window.matchMedia(DESKTOP_MQ).matches;

const enhanceHeroVideo = (video) => {
  const src = video.getAttribute('data-src');
  if (!src || video.dataset.enhanced === '1') {
    return;
  }
  if (!isDesktopVideoOk()) {
    return;
  }

  video.dataset.enhanced = '1';
  if (![...video.querySelectorAll('source')].some((el) => el.getAttribute('src') === src)) {
    const source = document.createElement('source');
    source.src = src;
    source.type = 'video/mp4';
    video.appendChild(source);
  }
  video.load();
  const onPlaying = () => {
    video.classList.add('is-playing');
  };
  video.addEventListener('playing', onPlaying, { once: true });
  const play = video.play();
  if (play && typeof play.catch === 'function') {
    play.catch(() => {});
  }
};

const enhanceHeroEmbed = (wrap) => {
  const src = wrap.getAttribute('data-src');
  const iframe = wrap.querySelector('iframe.home-hero__video-embed');
  if (!src || !iframe || wrap.dataset.enhanced === '1') {
    return;
  }
  if (!isDesktopVideoOk()) {
    return;
  }
  wrap.dataset.enhanced = '1';
  iframe.src = src;
};

const initHeroVideo = () => {
  document.querySelectorAll('.home-hero__video[data-src]').forEach(enhanceHeroVideo);
  document.querySelectorAll('.home-hero__video-embed-wrap[data-src]').forEach(enhanceHeroEmbed);
};

export default initHeroVideo;
